import { Program } from 'models';
import { ProgramAnalyticsMicroMessageContent } from 'models/analytics';

function getProgramAnalyticsMicroMessage(program: Program, programStatus: string) {
  const messageContent: ProgramAnalyticsMicroMessageContent = {
    programId: `${program.name}`,
    programName: `${program.title}`,
    programOnboardingStatus: `${programStatus ?? 'PREVIEW'}`,
  };

  return {
    schemaName: 'affiliateHubProgram',
    messageContent,
  };
}

export { getProgramAnalyticsMicroMessage };
